import { ShoppingCart, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  image_url: string;
  material: string;
  size: string;
  stock_quantity: number;
}

interface ProductGridProps {
  products: Product[];
  onAddToCart: (productId: string) => void;
}

export const ProductGrid = ({ products, onAddToCart }: ProductGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {products.map((product) => (
        <Card key={product.id} className="group hover:shadow-lg transition-shadow duration-300">
          <CardHeader className="p-0">
            <div className="relative overflow-hidden rounded-t-lg">
              <img
                src={product.image_url}
                alt={product.name}
                className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
              />
              {product.stock_quantity <= 5 && product.stock_quantity > 0 && (
                <Badge className="absolute top-2 right-2 bg-orange-500">
                  仅剩 {product.stock_quantity} 件
                </Badge>
              )}
              {product.stock_quantity === 0 && (
                <Badge className="absolute top-2 right-2 bg-red-500">
                  售罄
                </Badge>
              )}
            </div>
          </CardHeader>
          
          <CardContent className="p-4">
            <h3 className="font-semibold text-lg mb-2 line-clamp-2">
              {product.name}
            </h3>
            <p className="text-muted-foreground text-sm mb-3 line-clamp-2">
              {product.description}
            </p>
            
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center space-x-1">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 fill-yellow-400 text-yellow-400"
                  />
                ))}
                <span className="text-sm text-muted-foreground ml-1">(4.8)</span>
              </div>
            </div>

            <div className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">材质:</span>
                <span>{product.material}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">尺寸:</span>
                <span>{product.size}</span>
              </div>
            </div>
          </CardContent>
          
          <CardFooter className="p-4 pt-0">
            <div className="flex items-center justify-between w-full">
              <div className="text-2xl font-bold text-primary">
                ¥{product.price.toFixed(2)}
              </div>
              <Button
                onClick={() => onAddToCart(product.id)}
                disabled={product.stock_quantity === 0}
                className="flex items-center space-x-2"
              >
                <ShoppingCart className="w-4 h-4" />
                <span>{product.stock_quantity === 0 ? '售罄' : '加入购物车'}</span>
              </Button>
            </div>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
};